import { IconTypesProps } from '@/ui/components/svg/iconTypes'
import { Circle, Rect, Svg } from '@react-pdf/renderer'

const SvgStatusImportant = ({ primaryColor = '#F0F0F0' }: IconTypesProps) => (
    <Svg width="20" height="20" viewBox="0 0 24 24">
        <Circle cx="12" cy="12" r="12" fill="#FF8A00" />
        <Rect
            x="10.875"
            y="6.375"
            width="2.25"
            height="7.5"
            fill={primaryColor}
        />
        <Rect
            x="10.875"
            y="15.375"
            width="2.25"
            height="2.25"
            fill={primaryColor}
        />
    </Svg>
)

export default SvgStatusImportant
